import { render, staticRenderFns } from "./PdpEmailForm.vue?vue&type=template&id=6c86c0b4&scoped=true&"
import script from "./PdpEmailForm.vue?vue&type=script&lang=js&"
export * from "./PdpEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./PdpEmailForm.vue?vue&type=style&index=0&id=6c86c0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c86c0b4",
  null
  
)

export default component.exports